// @flow
import React from 'react';
import { useSelector } from 'react-redux';

import { Cart } from 'app/common/components/Shop';

import selectAvailableUuids from './selectAvailableUuids';


const CartPage = () => {
  const availableUuids = useSelector(selectAvailableUuids);

  return (
    <Cart availableUuids={availableUuids} />
  );
};

export default CartPage;
